import snuownd from 'snuownd';

export default snuownd.getParser();



// WEBPACK FOOTER //
// ./src/services/MarkdownParser.js